import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import InboxContainer from './InboxContainer';
import messages from '../../locale/jsonMessages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.inbox);

  // From Redux Store
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout ownerMenuPath="/inbox" ownerMenuWrapContent>
      <InboxContainer
        title={title}
      />
    </UserLayout>,
  };
};
